import mixpanel from 'mixpanel-browser';

export function trackMixPanelEvent(eventName, data = {}) {
  try {
    if (typeof mixpanel?.track === 'function') {
      mixpanel.track(eventName, data);
    }
  } catch (_) {}
}
